import React, { createContext, useState, useContext } from 'react';
import BetaModal from 'chat/BetaModal';
const BetaModalContext = createContext();
import { withToastManager } from 'ui/toast';
import { useJoinBetaProgram } from 'hooks/feature-flags/queries';

export const useModal = () => useContext(BetaModalContext);

export const BetaModalProvider = withToastManager(({children, toastManager, onReject}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = (data) => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const rejectBetaProgram = () => {
    setIsModalOpen(false);
    if (!!onReject) {
      onReject();
    }
  }

  const joinBetaProgramMutation = useJoinBetaProgram(
    () => {
      closeModal();
    },
    (error) => {
      // onError callback
      toastManager.add(
        'Error joining beta program. Please refresh and try again.', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 7000
      })
      rejectBetaProgram()
    }
  );

  const joinBetaProgram = () => {
    joinBetaProgramMutation.mutate();
  }


  return (
    <BetaModalContext.Provider value={{ openModal, closeModal, isModalOpen }}>
      {children} {/* This renders the parts of your app wrapped by the provider */}
      <BetaModal
        show={isModalOpen}
        onYes={joinBetaProgram}
        onNo={rejectBetaProgram}
      />
    </BetaModalContext.Provider>
  );
});
